














import { Component, Prop } from 'vue-property-decorator';
import { HalfWidthBlockViewObject } from '@/types/apiServerContract';
import BaseBlock from './BaseBlock.vue';

@Component
export default class HalfWidthBlock extends BaseBlock {
	@Prop({
	    required: true,
	    type: Object
	})
	content!: HalfWidthBlockViewObject;
}
